/**
 * 本地存储封装
 * 提供类型安全的localStorage操作
 */

/**
 * 存储键名枚举
 */
export const StorageKeys = {
  HISTORY: 'frey_game_history',
  SEARCH_HISTORY: 'frey_search_history',
  SETTINGS: 'frey_settings',
  THEME: 'frey_theme',
} as const;

export type StorageKey = typeof StorageKeys[keyof typeof StorageKeys];

/**
 * 设置存储项
 */
export function setStorageItem<T>(key: StorageKey, value: T): void {
  try {
    const serialized = JSON.stringify(value);
    localStorage.setItem(key, serialized);
  } catch (error) {
    console.error('Storage set error:', error);
  }
}

/**
 * 获取存储项
 */
export function getStorageItem<T>(key: StorageKey, defaultValue: T): T {
  try {
    const serialized = localStorage.getItem(key);
    if (serialized === null) {
      return defaultValue;
    }
    return JSON.parse(serialized) as T;
  } catch (error) {
    console.error('Storage get error:', error);
    return defaultValue;
  }
}

/**
 * 移除存储项
 */
export function removeStorageItem(key: StorageKey): void {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Storage remove error:', error);
  }
}

/**
 * 清空所有存储
 */
export function clearStorage(): void {
  try {
    localStorage.clear();
  } catch (error) {
    console.error('Storage clear error:', error);
  }
}
